export function tw(...classes) {
  return classes.filter(Boolean).join(' ')
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {}